import store from "@/core/services/store";
import baseModuleStore, {
    BASE_URL,
    ITEMS_ALL,
    MODULE_NAME as STORE_MODULE_NAME,
    SET_ITEMS_ALL,
    GET_ITEMS_ALL
} from "@/core/services/store/waybill-store/waybillStore";

const _MODULE_NAME_STORE = STORE_MODULE_NAME;

export default {
    beforeCreate() {
        function registerStoreModule(moduleName, storeModule) {
            if (!(store && store.state && store.state[moduleName])) {
                store.registerModule(moduleName, storeModule)
            }
        }

        registerStoreModule(_MODULE_NAME_STORE, baseModuleStore)
    },
    data() {
        return {};
    },
    computed: {
        storeAllItems() {
            return store.getters[_MODULE_NAME_STORE + '/' + ITEMS_ALL];
        },
        filters() {
            return {}
        }
    },
    methods: {
        getStoreAllItems(){
            this.$store.dispatch(_MODULE_NAME_STORE + '/' + GET_ITEMS_ALL, {
                filters: this.filters,
                url: BASE_URL
            })
        },
    },
    mounted() {
        if (!this.storeAllItems || this.storeAllItems.length  < 0 ) {
            this.$store.commit(_MODULE_NAME_STORE + '/' + SET_ITEMS_ALL, null);
            this.getStoreAllItems();
        }
    }
};
